// ABJ demo clone of src/components/abjDemo/abj_demo-ent-tgsp-3-6.js cut down to the Home Checklists (Preparing Your Home, listed under Planning 3.0).
// Created 10/19/26 for TO-1816. Route: /abj-demo-preparing-your-home
import React from 'react';
import Container from 'react-bootstrap/Container';
import {Nav} from "react-bootstrap";
import '@fortawesome/fontawesome-svg-core/styles.css';
import {HashLink as Link} from "react-router-hash-link";

const AbjDemoPreparingYourHome = () => {
    return (
        <div>
            <div className="w-100">
                <Container>
                    <div className="w-100">
                        <div className="col-10 m-auto">
                            <div className="whiteBackground floatLeft clearLeft">
                                <section>
                                    <div className="col-12">
                                        <div className="w-100">
                                            <h1 className="tileTitleHeader centeredPageHeader text-center abjHeadereb6d7d">Preparing Your Home</h1>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="w-100">
                                            <h3 id="setUpHome" className="sectionHeader text-center w-100">Home
                                                Checklists</h3>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="w-100">
                                            <p className="boldLeadIn">“Set Up Your Home” Checklist</p>
                                            <p>You will need time to recuperate after surgery. You may have some
                                                limitations on your physical activities. This checklist will help you
                                                prepare your home so recovery is easier. </p>
                                        </div>
                                    </div>
                                    <div className="l3SubheadUpperAndLowerBodyCopyAndRule">
                                        <div className="col-12 subheadAndBullets">
                                            <div className="w-100">
                                                <ul className="bulletsCustom colorAccentBlueGreenBullets">
                                                    <li>Make sure that you have arranged to stay with a caregiver all of
                                                        the time for the first few days after you arrive home.
                                                    </li>
                                                    <li>For your safety, put your favorite things in places you can
                                                        easily reach.
                                                    </li>
                                                    <li>Delay mail or have someone take care of your mail.</li>
                                                    <li>Have someone take care of your children and pets.</li>
                                                    <li>Secure someone to do your yard work.</li>
                                                    <li>Do laundry.</li>
                                                    <li>Clean your home.</li>
                                                    <li>Make sure all stairs at your home have a sturdy railing.</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="w-100">
                                            <p id="whatToBring" className="boldLeadIn">“What to Bring to the Hospital”
                                                Checklist </p>
                                            {/*<p>You will need time to recuperate after surgery. You may have some*/}
                                            {/*    limitations on your physical activities. This checklist will help you*/}
                                            {/*    prepare your home so recovery is easier.</p>*/}
                                        </div>
                                    </div>
                                    <div className="l3SubheadUpperAndLowerBodyCopyAndRule">
                                        <div className="col-12 subheadAndBullets">
                                            <div className="w-100">
                                                <ul className="bulletsCustom colorAccentBlueGreenBullets">
                                                    <li>An attitude of success - you will soon be on a journey to
                                                        recovery
                                                    </li>
                                                    <li>Phone numbers of anyone you wish to contact during your stay
                                                    </li>
                                                    <li>Your completed health history</li>
                                                    <li>Your medication record</li>
                                                    <li>Your insurance card</li>
                                                    <li>A photo ID, such as a driver’s license</li>
                                                    <li>Your prescription card</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="w-100">
                                            <p className="boldLeadIn">Please Leave Following Items at Home</p>
                                        </div>
                                    </div>
                                    <div className="l3SubheadUpperAndLowerBodyCopyAndRule">
                                        <div className="col-12 subheadAndBullets">
                                            <div className="w-100">
                                                <ul className="bulletsCustom colorAccentBlueGreenBullets">
                                                    <li>Jewelry</li>
                                                    <li>Valuables such as credit cards, checks and large amounts of
                                                        money
                                                    </li>
                                                    <li>Medications - your care team will give you all necessary
                                                        medications while you are in the hospital
                                                    </li>
                                                    <li>
                                                        If using the hospital’s Mobile Pharmacy to receive prescription
                                                        medications at discharge, please arrange with your caregiver to
                                                        bring cash,
                                                        check, or credit/debit card at discharge for payment of
                                                        medications.
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12 backToTop">
                                        <div className="w-100">
                                            <p><a className="specialUseBackToTop entPreparingSurgeryGreenColor"
                                                  onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}>BACK TO
                                                TOP <i className="fa fa-chevron-up"></i></a></p>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                    </div>
                </Container>
            </div>
        </div>

    )
};

export default AbjDemoPreparingYourHome;
